import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { colors, fonts, STAGE_HEIGHT, STAGE_WIDTH } from '../theme';
import { useIdleCursor } from '../hooks/useIdleCursor';
import { useStageScale } from '../hooks/useStageScale';
// Fixed 1920x1080 stage, scaled to fit the viewport with letterboxing.
export function ScreenFrame({ offline, children }) {
    const scale = useStageScale();
    const cursorIdle = useIdleCursor();
    return (_jsx("div", Object.assign({ style: {
            position: 'fixed',
            inset: 0,
            overflow: 'hidden',
            background: colors.letterbox,
            cursor: cursorIdle ? 'none' : 'default',
        } }, { children: _jsxs("div", Object.assign({ style: {
                position: 'absolute',
                left: '50%',
                top: '50%',
                width: STAGE_WIDTH,
                height: STAGE_HEIGHT,
                overflow: 'hidden',
                transform: `translate(-50%, -50%) scale(${scale})`,
                color: colors.text,
                fontFamily: fonts.sans,
                WebkitFontSmoothing: 'antialiased',
                // Cormorant defaults to old-style figures: numbers must line up and read from across the room.
                fontVariantNumeric: 'lining-nums',
            } }, { children: [children, offline && (_jsxs("div", Object.assign({ style: {
                        position: 'absolute',
                        left: 72,
                        bottom: 20,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        fontSize: 20,
                        color: colors.muted,
                    } }, { children: [_jsx("div", { style: { width: 10, height: 10, borderRadius: '50%', background: colors.danger } }), "\u043D\u0435\u0442 \u0441\u0432\u044F\u0437\u0438"] })))] })) })));
}
